import React from 'react';
import { useAppDispatch } from '@core/configureStore';
import { openModal } from '@core/features';
import { SocialPost } from '@core/models';
import { Card } from 'antd';
import SocialPostCardContent from './SocialPostCardContent';

type Props = {
  locationId: string;
  socialPost: SocialPost;
};

const SocialPostCard = ({ locationId, socialPost }: Props) => {
  const dispatch = useAppDispatch();

  const handleItemClicked = async (socialPost: SocialPost) => {
    await dispatch(
      openModal({
        modalName: 'socialPostModal',
        extraParams: {
          socialPost,
          locationId,
        },
      })
    );
  };

  return (
    <Card onClick={() => handleItemClicked(socialPost)} hoverable style={{ width: 350 }}>
      <SocialPostCardContent locationId={locationId} socialPost={socialPost} />
    </Card>
  );
};

export default SocialPostCard;
